import { Fund } from '../../fund-performance/dto/Fund';
import { Plan } from './Plan';
import { ManagementEntity } from './ManagementEntity';
import { RecoveryUserDTO } from "../../recovery/dto/RecoveryUserDTO";

export class Organization {
  public constructor(
    public id?: number,
    public name?: string,
    public logo?: string,
    public webSiteLink?: string,
    public address?: string,
    public founded?: string,
    public uuid?: string,
    public funds?: Fund[],
    public managementEntities?: ManagementEntity[],
    public selectedFund?: Fund,
    public organizationId?: number,
    public linkedIn?: string,
    public description?: string,
    public fmsAccess?: boolean,
    public kpiAccess?: boolean,
    public portalAccess?: boolean,
    public marketAnalysisAccess?: boolean,
    public financialStatementAccess?: boolean,
    public pdfAccess?: boolean,
    public dataRoomAccess?: boolean,
    public plan?: Plan,
    public isDeactivated?: boolean,
  ) { }


  static deserialize(object: any): Organization {
    return Object.assign(new Organization(), object) as Organization;
  }

  hasAnyAccess(): boolean {
    return this.fmsAccess || this.kpiAccess || this.portalAccess ||
      this.marketAnalysisAccess || this.financialStatementAccess || this.pdfAccess || this.dataRoomAccess;
  }
}

export class OrganizationForRecovery extends Organization {
  /**
   * Provides the number based on the funds, if they are used in statistics (see #Fund.isUsedInStatistics):
   * <pre>
   * 0 -> no fund
   * 1 -> all funds
   * 2 -> some of the funds.
   * </pre>
   */
  isUsedInStatistics: 0 | 1 | 2;
  showTeamMembers: boolean = false;
  users: RecoveryUserDTO[];

  static deserialize(object: any): OrganizationForRecovery {
    return Object.assign(new OrganizationForRecovery(), object) as OrganizationForRecovery;
  }

  /**
   * Provides the number based on the funds, if they are used in statistics:
   * 0 -> no fund
   * 1 -> all funds
   * 2 -> some of the funds.
   *
   * @param org which funds will be checked.
   */
  static getIsUsedInStatistics(org: Organization): 0 | 1 | 2 {
    const fundIsUsedInStatistics = org.funds.map((fund) => fund.isUsedInStatistics);
    if (fundIsUsedInStatistics.includes(true) && (fundIsUsedInStatistics.includes(false) || fundIsUsedInStatistics.includes(null))) {
      return 2; // is for '-'
    }
    if (fundIsUsedInStatistics.includes(true)) {
      return 1; // is for '+'
    }
    return 0; // is for empty checkbox
  }
}

export const OrganizationSorting = {
  byName: (o: Organization): string => o.name,
  byId: (o: Organization): number => o.organizationId,
  byPlanDate: (o: Organization): Date => o.plan?.agreementDate,
  byUseInStatistics: (o: Organization): number => o.funds.filter((fund) => fund.isUsedInStatistics).length,
  byFms: (o: Organization): boolean => o.fmsAccess,
  byAdminPortal: (o: Organization): boolean => o.portalAccess,
  byPdf: (o: Organization): boolean => o.pdfAccess,
  byFinancialStatement: (o: Organization): boolean => o.financialStatementAccess,
  byKpi: (o: Organization): boolean => o.kpiAccess,
  byMarketAnal: (o: Organization): boolean => o.marketAnalysisAccess,
  byDataRoom: (o: Organization): boolean => o.dataRoomAccess,
};

